export default __webpack_public_path__ + "static/media/Pot3.a25990c7.svg";